import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface SelectOption {
  value: string;
  label: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-select',
  styleUrl: './select.scss',
  templateUrl: './select.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
  ],
})
export class SelectComponent implements ControlValueAccessor {
  /** Libellé affiché au-dessus du champ. */
  @Input() label = '';

  /** Liste des options du champ. */
  @Input() options: SelectOption[] = [];

  /** Option par défaut (valeur vide). */
  @Input() placeholder = 'Sélectionner...';

  /** Texte d'aide affiché sous le champ. */
  @Input() hint = '';

  /** Message d'erreur affiché sous le champ. */
  @Input() error = '';

  /** Désactive le champ. */
  @Input() disabled = false;

  /** Identifiant HTML (lié au libellé). */
  @Input() id = '';

  protected value = '';

  private onChange: (value: string) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  writeValue(value: unknown): void {
    this.value = value == null ? '' : String(value);
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  protected onChangeSelection(event: Event): void {
    const target = event.target as HTMLSelectElement;
    this.value = target.value;
    this.onChange(this.value);
  }

  protected onBlur(): void {
    this.onTouched();
  }
}
